import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';
import {IonicApp, IonicErrorHandler, IonicModule} from 'ionic-angular';
import {SplashScreen} from '@ionic-native/splash-screen';
import {StatusBar} from '@ionic-native/status-bar';
import {Camera} from '@ionic-native/camera';
import {AngularFireModule} from 'angularfire2';
import {AngularFireAuthModule} from 'angularfire2/auth';
import {AngularFireDatabaseModule} from 'angularfire2/database';
import {MyApp} from './app.component';
import {ImageProvider} from '../providers/image/imageProvider';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {Http, HttpModule} from '@angular/http';
import {AvatarModule} from 'ngx-avatar';

import {environment} from '../environments/environment';
import {DatePipe} from '@angular/common'
import {FirebaseProvider} from "../providers/firebase/firebaseProvider";
import {DataCheckProvider} from "../providers/datacheck/dataCheckProvider";

import {AdminService} from "../pages/admin/adminService";
import {AdminUtil} from "../pages/admin/adminUtil";
import {FirebaseAuthProvider} from "../providers/firebase/firebaseAuthProvider";
import {LoginPage} from "../pages/login/login";
import {LoginPageModule} from "../pages/login/login.module";


// The translate loader needs to know where to load i18n files
// in Ionic's static asset pipeline.
export function HttpLoaderFactory(http: Http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        MyApp
    ],
    imports: [
        BrowserModule,
        IonicModule.forRoot(MyApp),
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireAuthModule,
        AngularFireDatabaseModule,
        HttpModule,
        AvatarModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [Http]
            }
        }),
        LoginPageModule
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        MyApp,
        LoginPage
    ],
    providers: [
        StatusBar,
        SplashScreen,
        Camera,
        {provide: ErrorHandler, useClass: IonicErrorHandler},
        AngularFireAuthModule,
        AngularFireModule,
        FirebaseProvider,
        FirebaseAuthProvider,
        ImageProvider,
        DataCheckProvider,
        DatePipe,
        AdminService,
        AdminUtil
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts